import React, { useState, useEffect } from 'react'
import { Card, CardBody, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { toast } from 'react-toastify';
import DataTable from 'react-data-table-component';
import { backendbaseUrl } from '../../../../Utils/baseUrl';
import axiosInstance from '../../../../Utils/axiosInstance';
import TrailRequestCardHeader from './TrailRequestCardHeader';
import FilterComponent from '../../../Miscellaneous/SupportTicket/TicketTable/FilterComponent';
import { TrailRequestcolumns } from '../../Company/TrailRequest/datas/TrailRequestDataConfiguration';
import CustomExpandableComponentsData from './CustomExpandableComponent';
import PlansaAndPricingFilterComponent from './PlansAndPricingFilterComponent';
import { PlansAndPricingcolumns } from './datas/PlanList';
import { useNavigate } from "react-router-dom";


export default function PlansAndPricingList() {
    const [filterText, setFilterText] = useState('');
    const [data, setData] = useState<any[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [planDelete, SetplanDelete] = useState(false);

    // State for Editing
    const [editRow, setEditRow] = useState<number | null>(null);
    const [editedValues, setEditedValues] = useState<any>({});

    const navigate = useNavigate()

    useEffect(() => {
        let url = `${backendbaseUrl}/plans/list/?page=${currentPage}`;
        if (filterText) url += `&search=${filterText}`;
        if (rowsPerPage) url += `&page_size=${rowsPerPage}`;

        axiosInstance.get(url)
            .then((response) => {
                setData(response.data.results);
                setTotalPages(Math.ceil(response.data.count / rowsPerPage));
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, [currentPage, filterText, rowsPerPage, planDelete]);

    const handlePageChange = (page: number) => setCurrentPage(page);
    const handleRowsPerPageChange = (newPerPage: number) => {
        setRowsPerPage(newPerPage);
        setCurrentPage(1);
    };



    const [modal, setModal] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null); // Store the item ID to delete


    const toggleModal = () => setModal(!modal);
    const toggleModal2 = () => setModal2(!modal2);

    // Open modal and set the item ID to be deleted
    const confirmDelete = (id: any) => {
        setItemToDelete(id);
        toggleModal();
    };




    const notEditable = (id: any) => {
        // setItemToDelete(id);
        toggleModal2();
    };




    const handleDelete = async () => {



        try {
            const response = await axiosInstance.delete(
                `${backendbaseUrl}/plans/delete/${itemToDelete}`
            );
            if (response.status === 204) {
                toast.success("Deleted Successfully")
                toggleModal();
                SetplanDelete(!planDelete)
            }

        } catch (error: any) {
            if (error.response) {
                if (error.response.status === 400) {
                    toast.error("Please fill every field");
                } else {
                    toast.error(
                        error.response.data.message || "An unknown error occurred"
                    );
                }
            } else {
                toast.error("Network error or server is down");
            }
        }

    }





    // When double-clicking, enable editing for the entire row
    const handleDoubleClick = (row: any) => {
        setEditRow(row.id);
        setEditedValues({
            first_name: row.first_name,
            email: row.email,
            company_name: row.company_name
        });
    };

    // Handle input changes for edited fields
    const handleChange = (rowId: number, e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setEditedValues((prev: { [key: string]: string }) => ({ ...prev, [name]: value }));

    };

    // Handle submitting changes
    const handleSubmit = (rowId: number) => {
        // Find the row and update the data
        setData((prevData) =>
            prevData.map((row) =>
                row.id === rowId ? { ...row, ...editedValues } : row
            )
        );

        // Send updated data to backend
        axiosInstance.put(`${backendbaseUrl}/company/company-trail/${rowId}/`, editedValues)
            .then(() => {
                console.log("Updated successfully!");
            })
            .catch((error) => {
                console.error("Error updating:", error);
            });

        // Exit edit mode
        setEditRow(null);
    };



    function CreatePlanPage(): void {
        navigate('/settings/plans-and-pricing/create-plans')
    }



    return (
        <div>
            <Col sm={12}>
                <Card>
                    <TrailRequestCardHeader headClass='pb-0 card-no-border' title={"All Plans and Pricing"} subTitle={"All Plans and pricing"} />
                    <CardBody>
                        <PlansaAndPricingFilterComponent
                            onFilter={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                            filterText={filterText} CreatePlanPage={CreatePlanPage}
                        />
                        <DataTable
                            className="custom-scrollbar"
                            data={data}
                            columns={PlansAndPricingcolumns(editRow, editedValues, handleDoubleClick, handleChange, handleSubmit, confirmDelete, notEditable)}

                            pagination
                            paginationServer
                            paginationTotalRows={totalPages * rowsPerPage}
                            paginationDefaultPage={currentPage}
                            onChangePage={handlePageChange}
                            onChangeRowsPerPage={handleRowsPerPageChange}

                            striped
                            highlightOnHover
                            paginationRowsPerPageOptions={[10, 25, 50]}
                        />
                    </CardBody>
                </Card>
            </Col>

            <Modal isOpen={modal} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>Confirm Deletion</ModalHeader>
                <ModalBody>
                    Please note that deleting a plan will not affect the company to which it has already been assigned. The plan will remain active for the company. However, if you wish to change the plan for the company that has already purchased it, this will be possible. We advise this change to avoid any future conflicts in our system
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleModal}>Cancel</Button>
                    <Button color="danger" onClick={handleDelete}>Delete</Button>
                </ModalFooter>
            </Modal>


            <Modal isOpen={modal2} toggle={toggleModal2}>
                <ModalHeader toggle={toggleModal2}>Cannot Edit</ModalHeader>
                <ModalBody>
                    Editing is not possible as it may clash with the system please delete and add new

                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleModal2}>Cancel</Button>
                    {/* <Button color="danger" onClick={handleDelete}>Delete</Button> */}
                </ModalFooter>
            </Modal>
        </div>



    );
}
